"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.anamnesticAlcoholAbuseMessages = exports.currentAlcoholAbuseMessages = exports.currentAlcoholUseMessages = exports.AnamnesticAlcoholAbuse = exports.CurrentAlcoholAbuse = exports.CurrentAlcoholUse = void 0;
const schema_1 = require("../../../schema");
var CurrentAlcoholUse;
(function (CurrentAlcoholUse) {
    CurrentAlcoholUse["NO"] = "No";
    CurrentAlcoholUse["OCCASIONALLY"] = "Occasionally";
    CurrentAlcoholUse["REGULARLY"] = "Regularly";
})(CurrentAlcoholUse || (exports.CurrentAlcoholUse = CurrentAlcoholUse = {}));
var CurrentAlcoholAbuse;
(function (CurrentAlcoholAbuse) {
    CurrentAlcoholAbuse["YES"] = "YES";
    CurrentAlcoholAbuse["NO"] = "NO";
})(CurrentAlcoholAbuse || (exports.CurrentAlcoholAbuse = CurrentAlcoholAbuse = {}));
var AnamnesticAlcoholAbuse;
(function (AnamnesticAlcoholAbuse) {
    AnamnesticAlcoholAbuse["YES"] = "YES";
    AnamnesticAlcoholAbuse["NO"] = "NO";
})(AnamnesticAlcoholAbuse || (exports.AnamnesticAlcoholAbuse = AnamnesticAlcoholAbuse = {}));
exports.currentAlcoholUseMessages = {
    [CurrentAlcoholUse.NO]: {
        id: "htx.risks.alcohol.currentAlcoholUse.NO",
        defaultMessage: "Nem fogyaszt"
    },
    [CurrentAlcoholUse.OCCASIONALLY]: {
        id: "htx.risks.alcohol.currentAlcoholUse.OCCASIONALLY",
        defaultMessage: "Alkalmanként"
    },
    [CurrentAlcoholUse.REGULARLY]: {
        id: "htx.risks.alcohol.currentAlcoholUse.REGULARLY",
        defaultMessage: "Rendszeresen"
    }
};
exports.currentAlcoholAbuseMessages = {
    [CurrentAlcoholAbuse.YES]: {
        id: "htx.risks.alcohol.currentAlcoholAbuse.YES",
        defaultMessage: "Igen"
    },
    [CurrentAlcoholAbuse.NO]: {
        id: "htx.risks.alcohol.currentAlcoholAbuse.NO",
        defaultMessage: "Nem"
    }
};
exports.anamnesticAlcoholAbuseMessages = {
    [AnamnesticAlcoholAbuse.YES]: {
        id: "htx.risks.alcohol.anamnesticAlcoholAbuse.YES",
        defaultMessage: "Igen"
    },
    [AnamnesticAlcoholAbuse.NO]: {
        id: "htx.risks.alcohol.anamnesticAlcoholAbuse.NO",
        defaultMessage: "Nem"
    }
};
const currentAlcoholUse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.NO),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.OCCASIONALLY),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholUse.REGULARLY)
])
    .interpretation({ vocab: "htx", code: "current_alcohol_use" })
    .tag({ vocab: "snomed", code: "219006" });
const currentAlcoholAbuse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentAlcoholAbuse.YES),
    schema_1.Schema.singleChoiceItem(CurrentAlcoholAbuse.NO)
])
    .interpretation({ vocab: "htx", code: "current_alcohol_abuse" })
    .tag({ vocab: "snomed", code: "15167005" })
    .tag({ vocab: "snomed", code: "15240007" });
const anamnesticAlcoholAbuse = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AnamnesticAlcoholAbuse.YES),
    schema_1.Schema.singleChoiceItem(AnamnesticAlcoholAbuse.NO)
])
    .interpretation({ vocab: "htx", code: "anamnestic_alcohol_abuse" })
    .tag({ vocab: "snomed", code: "15167005" })
    .tag({ vocab: "snomed", code: "410513005" });
const summaryOfAlcoholUse = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "htx", code: "summary_of_alcohol_use" })
    .tag({ vocab: "snomed", code: "371534008" })
    .tag({ vocab: "snomed", code: "713127001" });
exports.validator = schema_1.Schema.object().default({}).sealed(true).properties({
    currentAlcoholUse,
    currentAlcoholAbuse,
    anamnesticAlcoholAbuse,
    summaryOfAlcoholUse
});
